import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../../components/toast/Toast';
import { useCompleteWorkpaper } from '../../../queries/use-complete-workpaper';
import { useIntercom } from 'react-use-intercom';
import { intercomEvents } from '../../../intercom-events';

type CompleteWorkpaperDialogProps = {
    workpaperId: string;
    isOpen: boolean;
    onClose: () => void;
};

function CompleteWorkpaperDialog({ workpaperId, isOpen, onClose }: CompleteWorkpaperDialogProps): JSX.Element {
    const completeWorkpaperQuery = useCompleteWorkpaper(workpaperId);
    const { trackEvent } = useIntercom();
    function completeWorkpaper(): void {
        completeWorkpaperQuery.mutate(
            {},
            {
                onSuccess: () => {
                    onClose();
                    toastNotification('success', `Workpaper is completed!`);
                    trackEvent(intercomEvents.workpaper.completed.event);
                },
                onError: () => {
                    toastNotification('error', `Workpaper cannot be completed!`);
                },
            }
        );
    }

    return (
        <Dialog
            title="Complete Workpaper"
            description="Do you want to complete this workpaper? This workpaper will become locked."
            onClose={onClose}
            onPrimaryActionClick={completeWorkpaper}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Complete"
            secondaryAction="Cancel"
            type="success"
            isLoading={completeWorkpaperQuery.isLoading}
        />
    );
}

export default CompleteWorkpaperDialog;
